import { useSoundPath } from "hooks/useSoundPath";
import { CraftIdentityContext } from "pages/CraftIdentity";
import { useContext } from "react"
import { useNavigate } from "react-router-dom";


const QuickCraftButton = ({id, name}) => {
  const navigate = useNavigate();
  const playSound = useSoundPath();

  const {setMode, firstSelectedCard} = useContext(CraftIdentityContext);

  const submitHandler = () => {
    playSound('main');
    navigate(`?shortcut_data=${id},${firstSelectedCard.type.toLowerCase()},${firstSelectedCard.id},${name}`)
    setMode('fast-craft');
  }

  return (
    <button className='card-details__craft-sublist-item-button' onClick={submitHandler}>Quick Craft</button>
  )
}

export default QuickCraftButton;
